import React from 'react';

/**
 * Emit a JSON-LD `<script>` tag anywhere in the component tree.
 *
 * Crawlers (Googlebot, GPTBot, PerplexityBot, Applebot, etc.) all parse
 * `type="application/ld+json"` regardless of its position in the DOM —
 * no react-helmet / head manipulation needed. Pass a plain object; we
 * stringify once and hand React the raw string via `dangerouslySetInnerHTML`.
 *
 * Content is a hard-coded JSON object we built; there is no user input,
 * so no injection risk.
 */
export function JsonLd({ data }) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export default JsonLd;
